<section id="home">
  <div class="jumbotron j-rid text-center">
    <h2>Bienvenidos al RI-UNER</h2>
    <p class="container">Buscá cualquier tipo de producción intelectual, resultante de la actividad académica y de
      investigación de nuestra comunidad universitaria, en acceso libre y gratuito</p>
      <div class="search-container">
        <h3 class="search-title">¿Qué contenido estás necesitando?</h3>
        <ds-search-form-uner [inPlaceSearch]="false"
          [searchPlaceholder]="'home.search-form.placeholder' | translate" class="search-form"></ds-search-form-uner>
      </div>
  </div>
</section>